import { InputFieldV2Adapter } from '@zola/zola-ui/src/components/Form/InputFieldV2';

import cx from 'classnames';
import { Field } from 'react-final-form';

import { REQUIRED } from '~/components/common/form/commonValidations';

import styles from './nameField.module.less';

type NameFieldProps = {
  field: 'primary' | 'partner';
  label?: string;
  required?: boolean;
  firstNameFieldLabel?: string;
  lastNameFieldLabel?: string;
};
export const NameField = ({
  field,
  label,
  required,
  firstNameFieldLabel,
  lastNameFieldLabel,
}: NameFieldProps) => {
  const firstName = `${field}FirstName`;
  const lastName = `${field}LastName`;

  return (
    <fieldset className={styles.nameFieldSet}>
      {label && (
        <legend className={styles.nameLegend}>
          {label} {required && <div className={styles.asterisk}>*</div>}
        </legend>
      )}
      <div className={cx(styles.nameFields, { [styles.fullWidthFields]: !!firstNameFieldLabel })}>
        <Field
          id={firstName}
          name={firstName}
          component={InputFieldV2Adapter}
          placeholder={!firstNameFieldLabel ? 'First' : undefined}
          type="text"
          validate={REQUIRED}
          validateFields={[]}
          className={styles.nameField}
          label={firstNameFieldLabel}
        />

        <Field
          id={lastName}
          name={lastName}
          component={InputFieldV2Adapter}
          placeholder={!firstNameFieldLabel ? 'Last' : undefined}
          type="text"
          validate={REQUIRED}
          validateFields={[]}
          className={styles.nameField}
          label={lastNameFieldLabel}
        />
      </div>
    </fieldset>
  );
};
